import React from 'react'

import {makeStyles, withStyles} from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Stepper from '@material-ui/core/Stepper'
import Step from '@material-ui/core/Step'
import StepButton from '@material-ui/core/StepButton'
import StepLabel from '@material-ui/core/StepLabel'
import Check from '@material-ui/icons/Check'

import StepConnector from '@material-ui/core/StepConnector'

const useStyles = makeStyles(theme => ({
  root: {
    padding: '4px 24px'
  }
}))

const QontoConnector = withStyles({
  alternativeLabel: {
    top: 10,
    left: 'calc(-50% + 30px)',
    right: 'calc(50% + 30px)'
  },
  active: {
    '& $line': {
      borderColor: '#1943ef'
    }
  },
  completed: {
    '& $line': {
      borderColor: '#1943ef'
    }
  },
  line: {
    borderColor: '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1
  }
})(StepConnector)

const useQontoStepIconStyles = makeStyles({
  root: {
    color: '#eaeaf0',
    display: 'flex',
    height: 22,
    alignItems: 'center'
  },
  active: {
    color: '1943ef'
  },
  circle: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor'
  },
  completed: {
    color: '#1943ef',
    zIndex: 1,
    fontSize: 18
  }
})

function QontoStepIcon (props) {
  const classes = useQontoStepIconStyles()

  const {active, completed} = props

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active
      })}
    >
      {completed ? <Check className={classes.completed} /> : <div className={classes.circle} />}
    </div>
  )
}

QontoStepIcon.propTypes = {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool
}

const getSteps = () => ['Tier info', 'Besondere Situationen', 'Allgemeinzustand?', 'Vitalwerte', 'Trink & Fressverhalten?', 'Ausscheidungen', 'Ergebnisse']

const StepProgress = ({activeStep, handleStep}) => {
  const steps = getSteps()
  const classes = useStyles();

  return (
    <div className="stepper">

    <Stepper className={classes.root} alternativeLabel activeStep={activeStep - 1} connector={<QontoConnector />}>
      {steps.map((label, index) => (
        <Step key={label}>
          <StepButton onClick={() => handleStep(index)} className="stepProgress__button" >
            <StepLabel StepIconComponent={QontoStepIcon}>{label}</StepLabel>
          </StepButton>
        </Step>
      ))}
    </Stepper>
      </div>

  )
}

export default StepProgress
